module.exports = __webpack_public_path__ + "img/logo.7bd98a9f.png";